import { render, staticRenderFns } from "./BUpload.vue?vue&type=template&id=1b205e5c&scoped=true&"
import script from "./BUpload.vue?vue&type=script&lang=js&"
export * from "./BUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b205e5c",
  null
  
)

export default component.exports